import { Show, TextInput } from "components/core";

import { CreateEmployeeAccountVariables } from "_graphql/mutation/__generated__/CreateEmployeeAccount";
import { FC } from "react";
import { FormikProps } from "formik";
import RolePicker from "components/core/role-picker";

export interface EmployeeFormProps {
    form: FormikProps<CreateEmployeeAccountVariables["employee"]>;
    update?: boolean;
}

const EmployeeForm: FC<EmployeeFormProps> = ({ form, update }) => {
    return (
        <div className="space-y-6 divide-y divide-gray-200">
            {/* {JSON.stringify(form.values, null, 2)} */}
            <div>
                <span className="text-xs  text-secondary">
                    Employee Information
                </span>
                <div className="grid grid-cols-2 gap-2">
                    <div>
                        <TextInput
                            id="employee_first_name"
                            label="First Name"
                            type="text"
                            placeholder="e.g. Emmanuel"
                            required={true}
                            {...form}
                        />
                    </div>

                    <div className="space-y-1 ">
                        <TextInput
                            id="employee_last_name"
                            label="Last Name"
                            type="text"
                            placeholder="e.g. Baidoo"
                            required={true}
                            {...form}
                        />
                    </div>
                    <div>
                        <TextInput
                            id="employee_email"
                            label="Email"
                            type="text"
                            placeholder="e.g. ebaidoo79@gmail.com"
                            required={true}
                            {...form}
                        />
                    </div>

                    <div className="space-y-1 ">
                        <TextInput
                            id="employee_phonenumber"
                            label="Phone Number"
                            type="text"
                            placeholder="e.g. 0506339153"
                            required={true}
                            {...form}
                        />
                    </div>
                    <div className="space-y-1 col-span-2 ">
                        <RolePicker
                            id="broker_role_id"
                            label="Position"
                            placeholder="e.g. System Admin"
                            required={true}
                            // rawId={false}
                            // multiple
                            {...form}
                        />
                        <Show
                            if={Boolean(form.touched.broker_role_id && update)}>
                            <div className="bg-yellow-50 p-2 rounded">
                                <p className="text-xs text-yellow-600">
                                    If you update the employee's role, please
                                    ensure that you inform them. They will need
                                    to log in again to access their new
                                    permissions.
                                </p>
                            </div>
                        </Show>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmployeeForm;
